import request from '@/router/axios';

const urlPrefix = process.env.VUE_APP_LOCAL_DEVELOPMENT == 'false' ? '/sys' : '/sys'


//获取cusId机构数据
export function queryOrgTree(id) {
  return request({
    url: urlPrefix + '/org/tree/'+id,
    method: 'get',
  });
}
//获取cusId机构数据,treeSelect
export function queryOrgTreeSelect(id) {
  return request({
    url: urlPrefix + '/org/treeSelect/'+id,
    method: 'get',
  });
}
//获取客户下的公司列表,没分公司返回机构根
export function queryCompanyOrgList(id) {
  return request({
    url: urlPrefix + '/org/cus/company/'+id,
    method: 'get',
  });
}
//获取客户下的公司列表,没分公司返回机构根
export function orgWageBizProcess(id) {
  return request({
    url: urlPrefix + '/process/org/'+id,
    method: 'get',
  });
}


//根据token查询用户的递归所有机构
export function queryPmsOrgList(cusId,userId) {
  return request({
    url: urlPrefix + '/process/org/'+cusId+'/'+userId,
    method: 'get',
  });
}
